module.exports = __webpack_public_path__ + "img/seven.be5030ca.webp";